export default __webpack_public_path__ + "static/media/Marked Serpentweave.4363121b.jpg";